import { ICreative } from '@/Interfaces/Creatives/Creative.interface';
import { CREATIVE_IN_USE_ARCHIVE_DISABLED_REASON } from '@/constants/creativeLibrary';
import { SquareRounded } from '@mui/icons-material';
import { Checkbox, Tooltip } from '@mui/material';
import { GRID_CHECKBOX_SELECTION_COL_DEF, GridCellCheckboxRenderer, GridRenderCellParams } from '@mui/x-data-grid-pro';

const CheckboxCell = {
  ...GRID_CHECKBOX_SELECTION_COL_DEF,
  renderCell: (params: GridRenderCellParams<ICreative>) => {
    const { row } = params;

    if (!row.isArchived && row.isInUse) {
      return (
        <Tooltip title={CREATIVE_IN_USE_ARCHIVE_DISABLED_REASON} placement='top' arrow>
          <span className='cursor-not-allowed'>
            <Checkbox disabled icon={<SquareRounded sx={{ color: '#E0E0E0' }} />} />
          </span>
        </Tooltip>
      );
    }

    return <GridCellCheckboxRenderer {...params} />;
  },
};

export default CheckboxCell;
